import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TablePagination from "@mui/material/TablePagination";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import {
  useTaskListSubscription,
  EMPTY_FILTERS,
  type TaskListFilters as FiltersType,
} from "./useTaskListSubscription";
import { TaskListFilters } from "./TaskListFilters";
import { TaskDataGrid } from "./TaskDataGrid";
import { IfPermission } from "../../auth/IfPermission";

export function TaskList() {
  const [filters, setFilters] = useState<FiltersType>(EMPTY_FILTERS);
  const { state, fetching, page, pageSize, setPage, setPageSize } =
    useTaskListSubscription(filters);
  const navigate = useNavigate();

  const handleFiltersChange = (next: FiltersType) => {
    setFilters(next);
    setPage(1);
  };

  // MUI считает страницы с нуля, экран — с единицы.
  const zeroBasedPage = page - 1;

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Задачи</Typography>
        <IfPermission permission="tasks.create">
          <Button variant="contained" onClick={() => {
      void navigate("/tasks/create");
    }}>
            Создать задачу
          </Button>
        </IfPermission>
      </Box>

      <Box mb={2}>
        <TaskListFilters onChange={handleFiltersChange} />
      </Box>

      {fetching && <LinearProgress sx={{ mb: 1 }} />}

      {state.kind === "loading" && (
        <Box display="flex" justifyContent="center" p={6}>
          <CircularProgress />
        </Box>
      )}

      {state.kind === "error" && (
        <Alert severity="error">Ошибка подключения. Переподключение…</Alert>
      )}

      {state.kind === "empty" && (
        <Box textAlign="center" py={4}>
          <Typography>Задач пока нет</Typography>
        </Box>
      )}

      {state.kind === "data" && (
        <>
          <TaskDataGrid items={state.items} />
          <TablePagination
            component="div"
            count={state.totalCount}
            page={zeroBasedPage}
            onPageChange={(_event, newPage) => setPage(newPage + 1)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(event) => setPageSize(Number(event.target.value))}
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage="На странице:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}–${to} из ${count}`
            }
          />
        </>
      )}
    </Box>
  );
}
